import { render, staticRenderFns } from "./MerchantIDTooltip.vue?vue&type=template&id=2e4e5aa6&scoped=true&"
import script from "./MerchantIDTooltip.vue?vue&type=script&lang=ts&"
export * from "./MerchantIDTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantIDTooltip.vue?vue&type=style&index=0&id=2e4e5aa6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e5aa6",
  null
  
)

export default component.exports